import { useState, useEffect } from 'react';
import { getCollection, subscribe } from '../db';

// Sottoscrizione live a una collezione del tenant. Ritorna sempre un array.
// Si riallinea ad ogni mutazione dello store (subscribe/emit).
export function useCollection(tenantId, collName) {
  const [data, setData] = useState(() => (tenantId ? getCollection(tenantId, collName) : []));

  useEffect(() => {
    if (!tenantId || typeof window === 'undefined') { setData([]); return; }
    const update = () => setData(getCollection(tenantId, collName));
    update();
    return subscribe(update);
  }, [tenantId, collName]);

  return data;
}
